import { render, staticRenderFns } from "./SysParameters.vue?vue&type=template&id=2dc18e57"
import script from "./SysParameters.vue?vue&type=script&lang=js"
export * from "./SysParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports